<template>
  <div id="main-wrapper" class="login-wrap">
    <div class="container h-100">
      <div class="row justify-content-md-center align-items-center h-100">
        <div class="col-lg-8">
          <div class="card w-100 rounded-10 px-4 py-3">
            <div class="card-header text-center bg-white rounded-10">
              <img src="/images/Tokoin-Logo.svg?=2" width="220" />
              <p class="font-24">{{$lang.messages.forgot_password}}</p>
            </div>

            <div class="card-body">
              <form class="form-style">
                <div class="form-group text-center">
                  <span class="help is-danger">{{errorMessage}}</span>
                </div>
                <div class="form-group">
                  <label for="email">{{$lang.messages.email}}</label>
                  <input
                    name="email"  v-on:keydown.enter.prevent="validateBeforeSubmit"
                    v-model="email"
                    v-validate="'required|email'"
                    :class="{ 'form-control' : true, 'input': true, 'is-danger': errors.has('email') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.email"
                  />
                  <i v-show="errors.has('email')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('email')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_email}}</span>
                </div>

                <button type="button" id="save-btn"  @click="validateBeforeSubmit"  class="btn btn-primary btn-block">{{$lang.messages.submit}}</button>
				
              </form>
            </div>
            <div class="card-footer text-center bg-white rounded-10">
              <div class="d-flex justify-content-center links">
                {{$lang.messages.back_to}}
                <a class="ml-2 text-primary">
                  <router-link to="/login">{{$lang.messages.login}}</router-link>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";
export default {
  name: "ForgotPassword",
  data(){
    return{
      errorMessage: "",
      email: ""
    }
  },
   methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.forgotPassword();
          return;
        }
      });
    },
    forgotPassword(){
        this.errorMessage = "";
          this.$api
        .postAPI({
          _action: "/forgot_password",
          _body: {email: this.email},
          _buttonId: "save-btn"
        })
        .then(res => {
          alert( res.message)
           router.push("/login");
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
        })
        .catch(e => {
          this.errorMessage = e.message;
        });
    }
   }
};
</script>
